const SORT_VALUES = { asc: 'asc', desc: 'desc' };

const SIGNATURE_TYPE = {
  video: 'Video',
  image: 'Signature',
};

export { SORT_VALUES, SIGNATURE_TYPE };
